import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import { toast } from '../hooks/use-toast';
import { Star } from 'lucide-react';

const Feedback = ({ onDeposit }) => {
  const [rating, setRating] = useState(5);
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');

  const submit = () => {
    if (!message.trim()) { toast({ title: 'Please write your feedback' }); return; }
    toast({ title: 'Feedback submitted', description: 'Thanks — your feedback has been recorded.' });
    setMessage(''); setSubject(''); setRating(5);
  };

  return (
    <div>
      <Topbar count={0} title="FEEDBACK" subtitleUnit="Reports" onDeposit={onDeposit} />
      <div className="px-8 py-6 font-mono max-w-[720px]">
        <div className="border border-[#151515] rounded-md p-6 bg-[#0a0a0a]">
          <h2 className="text-[#e6e6e6] text-lg">Share your feedback</h2>
          <p className="text-[12px] text-[#7a7a7a] mt-1">Help us improve the terminal. Ratings are anonymous.</p>

          <div className="mt-5">
            <div className="text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-2">RATING</div>
            <div className="flex gap-1.5">
              {[1, 2, 3, 4, 5].map((v) => (
                <button key={v} onClick={() => setRating(v)} className="p-1 transition-colors">
                  <Star size={22} className={v <= rating ? 'text-[#22c55e] fill-[#22c55e]' : 'text-[#3a3a3a]'} />
                </button>
              ))}
            </div>
          </div>

          <div className="mt-5">
            <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1.5">SUBJECT</label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="e.g. Checkout experience"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          <div className="mt-4">
            <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1.5">MESSAGE</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={5}
              placeholder="Tell us what could be better…"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e] transition-colors resize-none"
            />
          </div>
          <button
            onClick={submit}
            className="mt-5 px-5 py-2 text-[11px] tracking-[0.25em] rounded-md bg-[#166534] hover:bg-[#15803d] text-[#e7ffef] transition-colors"
          >SUBMIT FEEDBACK</button>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
